// extracted by mini-css-extract-plugin
export default {"container":"NavigationButtons_container__KW8V0","content":"NavigationButtons_content__C02L-"};